import fatherImage from 'assets/images/parenting-quiz-v2-gender-father.webp'
import motherImage from 'assets/images/parenting-quiz-v2-gender-mother.webp'

import { Gender } from 'root-constants'

import { TGenderOption } from '../types'

export const PARENT_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.mother',
    imageUrl: motherImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.father',
    imageUrl: fatherImage,
  },
] as const satisfies readonly TGenderOption[]

export const PARENT_GENDER_QUIZ_V3_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: motherImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: fatherImage,
  },
] as const satisfies readonly TGenderOption[]
